export default (function amazzingFilterInit() {
    const amazzingFilter = {
        clearOneFilter() {
            const buttonClear = $('.js--af_filter_content__clear_button');

            if (buttonClear && buttonClear.length) {
                buttonClear.on('click', function () {
                    $(this).prev().children('.filter_item').each(function () {
                        if ($(this).hasClass('active')) {
                            $(this).find('input').click();
                        }
                    });
                });
            }
        },

        toggleFilterContent() {
            const radioFilterItems = $('.js--af_filter').find('.js--radio .filter_item .js--custom_radio_filter');

            if (radioFilterItems.length) {
                radioFilterItems.on('click', function () {
                    $(this).parents('.js--af_filter').addClass('closed');
                });
            }
        },
    };
    $(document).ready(() => {
        amazzingFilter.clearOneFilter();
        amazzingFilter.toggleFilterContent();
    });
}());
